<template>
  <div>
    <s-text
      :label="label"
      clearable
      @keyupEnter="keyEnterPress"
      v-model="CodSenasa"
    >
      <template v-slot:append="">
        <v-icon
          style="cursor: pointer !important"
          class="mt-1 mr-2"
          @click="keyEnterPress"
          title="Buscar"
        >
          mdi-arrow-right-bold-circle
        </v-icon>
        <v-icon
          style="cursor: pointer !important"
          class="mt-1"
          @click="showFarmLot = true"
        >
          mdi-magnify</v-icon
        >
      </template>
    </s-text>
    <v-dialog v-if="showFarmLot" v-model="showFarmLot">
      <v-card>
        <FarmLot @dblClick="dblclick($event)" :FltLevel="1"></FarmLot>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialog" v-model="dialog" width="80%">
      <v-card>
        <s-toolbar
          dark
          color="primary"
          close
          :label="'Código de Senasa   ' + CodSenasa"
          @close="close"
        >
        </s-toolbar>
        <v-col lg="12">
          <v-data-table
            dense
            @dblclick:row="dblclickSenasa"
            :items="itemsLots"
            :headers="config.headers"
          >
          </v-data-table>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _sFarm from "@/services/Technicalassistance/AgriculturalFarmsService";
import FarmLot from "@/views/TechnicalAssistance/Certification/FarmLot";
import { validate } from "autonumeric";
export default {
  components: { FarmLot },
  props: {
    label: {
      type: String,
      default: "ID LOTE", //Cod Senasa
    },
    FagIDg: {
      type: Number,
      default: 0,
    },
    value: {
      type: [String, Number],
      default: "",
    },
    // Nueva prop: fecha de la visita para enviar al backend en la búsqueda
    visitDate: {
      type: [String, Date],
      default: null,
    },
    validateAlert: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showFarmLot: false,
      CodSenasa: this.value || "",
      dialog: false,
      config: {
        model: {
          FltID: "ID",
          FltName: "string",
          PrdID: "int",
          PrdText: "string",
        },

        headers: [
          { text: "ID", value: "FltID", sortable: true },
          { text: "Nombre Lote", value: "FltName" },
          { text: "Fundo", value: "FagName" },
          { text: "Nombre Productor", value: "PrdText", sortable: true },
          { text: "Tipo Cultivo", value: "TypeCropText", sortable: true },
          { text: "Cultivo", value: "TypeCultiveText", sortable: true },
          { text: "Variedad", value: "VrtDescription", sortable: true },
        ],
      },
      itemsLots: [],
    };
  },

  watch: {
    // Watcher para sincronizar cambios internos con v-model
    CodSenasa(newVal) {
      this.$emit("input", newVal); // Emite para v-model
      this.$emit("searchSenasa", null);
    },
    // Watcher para sincronizar cambios externos con el valor interno
    value(newVal) {
      if (newVal !== this.CodSenasa) {
        this.CodSenasa = newVal || "";
      }
    },
  },

  methods: {
    triggerSearch(fltID) {
      this.CodSenasa = fltID ? fltID.toString() : "";
      this.$nextTick(() => {
        this.keyEnterPress();
      });
    },
    keyEnterPress() {
      if (this.CodSenasa.trim() == "") {
        this.dialog = true;
      }
      let ObjSenasa = {
        CodSenasa: this.CodSenasa,
        FagID: this.FagIDg,
        Date: this.visitDate || this.$fun.getDate(),
        ValidateAlert: this.validateAlert ? 1 : 0,
      };
      
      _sFarm.listFarm(ObjSenasa, this.$fun.getUserID()).then((response) => {
        if (response.data != null) {
          this.itemsLots = response.data;
          if (response.data.length == 1) {
            this.$emit("searchSenasa", response.data[0]);
          } else if (response.data.length > 1) {
            this.dialog = true;
          } else this.$emit("searchSenasa", null);
        }
      });
    },

    close() {
      this.dialog = false;
    },

    dblclick(item) {
      item.VrtDescription = item.VrtIDText;
      item.TypeCultiveText = item.CultiveText;
      item.PrdText = item.PrdCardName;
      // Actualizar el v-model con el ID seleccionado
      this.CodSenasa = item.FltID ? item.FltID.toString() : "";
      this.$emit("searchSenasa", item);
      this.showFarmLot = false;
    },
    dblclickSenasa(event, { item }) {
      // Actualizar el v-model con el ID seleccionado
      this.CodSenasa = item.FltID ? item.FltID.toString() : "";
      this.$emit("searchSenasa", item);
      this.dialog = false;
    },
  },
};
</script>
